@if (product$ | async; as product) {
  <app-custom-product-tags [tags]="product.categoryTags"></app-custom-product-tags>
  <div class="manufacturer" [innerHTML]="product?.manufacturer"></div>
  <h1 class="h2-component name">
    {{ product?.name }}
  </h1>
  @if (product?.summary) {
    <div class="summary">
      {{ product.summary }}
    </div>
  }
  @if (product?.subTitle) {
    <h2 class="subtitle">
      {{ product.subTitle }}
    </h2>
  }
  <app-custom-trustedshops-widget [product]="product" widgetType="ProductStarsRating"></app-custom-trustedshops-widget>
  <div class="stock-message">{{ product.stockMessage }}</div>
}
